// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import Notification, { clsText, NotificationProps } from 'src/components/notifications/notification'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'

// images
import * as overlayInactive from 'src/components/notifications/badges/Comment@2x.png'
import * as overlayActive from 'src/components/notifications/badges/CommentActive@2x.png'

type RecommentNotificationProps = {
  message: string;
  createdAt: string;
} & Pick<NotificationProps, 'avatarImage' | 'isRead' | 'onClick' >

const RecommentNotification: React.FC<RecommentNotificationProps> = ({
  avatarImage,
  message,
  createdAt,
  isRead,
  onClick
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      badgeImageRead={overlayInactive}
      badgeImageNotRead={overlayActive}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={''}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{message}</span>
    </Notification>
  )
}

export default RecommentNotification
